<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form>
            <div class="basic-title"><em>面试官关联学校</em></div>
            <div
              class="box-content">
              <label class="form-tit">学校信息</label>
              <jm-school-search
                class="jm-input220"
                :country-id="83"
                ref="school_search"
                v-model="school"
              />
            </div>
            <el-button
              type="primary"
              @click="relation()">确定关联</el-button>
          </el-form>
        </div>
      </div>
      <div class="school-name-div">
        <span>已关联学校(点击可取消关联)：</span>
        <span
          title="取消关联"
          class="school-name"
          v-for="(item,key) in schoolList"
          :label="item"
          :value="item"
          :key="key"
          @click="cancelRelation(key)">{{ item }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/index.css';
import toolbar from '@/components/tool/toolbar.vue';
import student from '@/pages/student/student';
import { jmSchoolSearch } from '@/components/tool';

export default {
  mixins: [student],
  data() {
    return {
      school: '',
      schoolList: [],
    };
  },
  components: {
    'jm-toolbar': toolbar,
    jmSchoolSearch,
  },
  created() {
    this.getRelation();
  },
  methods: {
    // 关联学校
    relation() {
      if (this.school.sh_id === '') {
        this.$message.error('请选择关联的学校');
        return false;
      }
      this.$http._post({
        url: '/interview/inform/save',
        data: {
          userId: this.$route.params.userid,
          schoolId: this.school.sh_id,
        },
      }).then(({ data }) => {
        if (data.code === -1) {
          this.$message.error(data.msg);
        } else {
          this.$message.success(data);
          this.getRelation();
        }
      });
    },
    getRelation() {
      this.$http._post({
        url: '/interview/inform/read',
        data: {
          userId: this.$route.params.userid,
        }
      }).then(({ data }) => {
        this.schoolList = data;
      });
    },
    cancelRelation(id) {
      this.$confirm('此操作将取消面试官对此学校的关联, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/interview/inform/deleteRelation',
          data: { id: id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({
              type: 'success',
              message: '取消关联成功!'
            });
            this.getRelation();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  },
};
</script>
<style>
  .school-name-div{
    margin-left: 50px;
  }
  .school-name{
    display: inline-block;
    background-color: #409EFF;
    color: white;
    padding: 10px;
    border-radius: 5px;
    margin-left: 30px;
    cursor: pointer;
    margin-top: 10px;
  }
</style>
